<app-header-empty></app-header-empty>
<div class="header-divider"></div>
<app-form-template
  [title]="'TWO_FACTOR_FORM.TITLE' | translate"
  [formGroup]="twofaForm"
  [submit]="submitToken"
>
  <div class="description">
    {{ "TWO_FACTOR_FORM.DESCRIPTION" | translate }}
  </div>

  <payee-otp-form-field
    width="wide"
    formControlName="code"
    (completed)="submitToken()"
  >
    <span payee-label>{{ "TWO_FACTOR_FORM.CODE_LABEL" | translate }}</span>
    @if (code.dirty || code.touched) {
      <ng-container payee-error>
        @if (code.hasError("required") || code.hasError("pattern")) {
          <span payee-error>{{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}</span>
        }
        @if (code.hasError("invalidCode")) {
          <span payee-error>{{ "TWO_FACTOR_DIALOG.INVALID_CODE" | translate }}</span>
        }
      </ng-container>
    }
  </payee-otp-form-field>

  <button
    payee-button
    width="wide"
    type="submit"
    [disabled]="loading() || twofaForm.invalid"
  >
    {{ "TWO_FACTOR_FORM.SUBMIT" | translate }}
    @if (loading()) {
      <div class="bw-theme flex hcenter">
        <mat-progress-spinner
          color="accent"
          mode="indeterminate"
          diameter="30"
        ></mat-progress-spinner>
      </div>
    }
  </button>
</app-form-template>
